import clsx from "clsx";
import { ReactNode } from "react";

interface IInvertedDivProps {
	absolute?: boolean;
	children: ReactNode;
}

export const InvertedDiv = ({ absolute, children }: IInvertedDivProps) => {
	return (
		<div
			className={clsx("-z-10 [&:first-of-type]:z-10 t-0 l-0 will-change-transform", {
				relative: !absolute,
				absolute,
			})}
		>
			{children}
		</div>
	);
};
